import { useTranslation } from "react-i18next";

const CompanyPartnersSection = () => {
  const { t } = useTranslation();
  const images = [
    "/alageum.png",
    "/kegoc.svg",
    "/emmo.svg",
    "/samruk-energy.svg",
    "/yassy.png",
    "/alageum.png",
    "/kegoc.svg",
    "/emmo.svg",
    "/samruk-energy.svg",
    "/yassy.png",
    "/alageum.png",
    "/kegoc.svg",
    "/emmo.svg",
    "/samruk-energy.svg",
    "/yassy.png",
    "/alageum.png",
    "/kegoc.svg",
    "/emmo.svg",
    "/samruk-energy.svg",
    "/yassy.png",
  ];

  return (
    <section
      id="partners"
      className="w-full max-w-full h-[300px] lg:h-[610px] relative bg-red-900 overflow-x-hidden"
    >
      <div className="w-full lg:top-[80px] top-10 absolute text-center text-neutral-50 text-[30px] lg:text-5xl font-normal font-['Forum'] uppercase leading-[36px] lg:leading-[75px]">
        {t("partners.title")}
      </div>


      <div className="relative h-full w-full max-w-full overflow-x-hidden top-[30px] md:top-0">
        <div className="size-48 md:size-64 lg:size-96 bg-red-900 rounded-full blur-2xl absolute left-[-100px] md:left-[-120px] lg:left-[-180px] top-1/2 -translate-y-1/2 z-10 pointer-events-none" />
        <div className="h-full w-full max-w-full flex items-center gap-8 md:gap-16 lg:gap-[135px] animate-scroll-left">
          {images.map((image, index) => (
            <img key={`${image}-${index}`} src={image} alt={image} className="h-16 lg:h-28 flex-shrink-0" />
          ))}
          {images.map((image, index) => (
            <img key={`${image}-duplicate-${index}`} src={image} alt={image} className="h-16 lg:h-28 flex-shrink-0" />
          ))}
        </div>
        <div className="size-48 md:size-64 lg:size-96 bg-red-900 rounded-full blur-2xl absolute right-[-100px] md:right-[-120px] lg:right-[-180px] top-1/2 -translate-y-1/2 z-10 pointer-events-none" />
      </div>

    </section>
  );
};

export default CompanyPartnersSection;

